import React from "react";
import * as styles from "./Caracteristicas.module.scss";
import { motion } from "framer-motion";
import potencia from "../../../icons/details/potencia.svg";
import medidas from "../../../icons/details/medidas.svg";
import detalles from "../../../icons/details/peso.svg";
import sistema from "../../../icons/details/sistema.svg";

const Caracteristicas = () => {
  return (
    <motion.section className={styles.main_section8}>
      <div className={styles.container}>
        <div className={styles.container_text}>
          <div className={styles.title}>
            <h1>Tu café de especialidad, ahora en casa</h1>
          </div>
          <div className={styles.text}>
            <p>
              Versátil, fácil de usar y con un sofisticado diseño que embellece
              cualquier cocina, esta moderna cafetera se convertirá en tu aliada
              para sorprender a la familia y agasajar a tus invitados.
              Redescubrí la forma de hacer y tomar café con Peabody, adquirí tu
              Cafetera Express PE-CE5007IXN hoy.
            </p>
          </div>
        </div>

        <div className={styles.container_icons}>
          <div className={styles.icon}>
            <div className={styles.circle_icon}>
              <img src={potencia} alt="potencia" />
            </div>

            <div className={styles.container_info}>
              <h2>Potencia</h2>
              <p>1350W</p>
            </div>
          </div>

          <div className={styles.icon}>
            <div className={styles.circle_icon}>
              <img src={medidas} alt="potencia" />
            </div>

            <div className={styles.container_info}>
              <h2>Detalles</h2>
              <p>De acero inoxidable</p>
            </div>
          </div>

          <div className={styles.icon}>
            <div className={styles.circle_icon}>
              <img src={detalles} alt="potencia" />
            </div>

            <div className={styles.container_info}>
              <h2>Medidas</h2>
              <p>Alto 21.5 cm Ancho 29.5 cm Profundidad 31.7 cm.</p>
            </div>
          </div>

          <div className={styles.icon}>
            <div className={styles.circle_icon}>
              <img src={sistema} alt="potencia" />
            </div>

            <div className={styles.container_info}>
              <h2>Presión</h2>
              <p>20 bares de presión</p>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Caracteristicas;
